/* eslint-disable */
import { useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify'

// helpers
import { groupBy } from '../../helpers/general';

// actions
import { getUsers as fetchUsers } from '../../store/actions/users';

// selectors
import { getFilteredUsers } from '../../store/selectors/users';

const useUsers = () => {
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useDispatch();
  const users = useSelector(getFilteredUsers);
  const getUsers = async (searchText = '') => {
    try {
      setIsLoading(true);
      let trimmedText = searchText.trim()
      const res = await dispatch(fetchUsers(trimmedText)).unwrap();
      const users = res.resources
      if (users.length === 0) {
        toast.error('No matching records found, please modify your search and try again')
      }
    } catch (error) {
      toast.error(error?.message)
    } finally {
      setIsLoading(false)
    }
  };

  const usersById = useMemo(() => groupBy(users, 'id'), [users])

  return { users, areUsersLoading: isLoading, getUsers, usersById };
};

export default useUsers;
